import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SessionAnuglarService } from './../../core/session-anuglar.service';
import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { Funcoes } from '../model/funcoes';
import { UserUtil } from '../../core/user-util';
import { CsiHttp } from '../../core/csi-http';

@Injectable()
export class AuthenticationService {

  private apiUrl = environment.principalAPI;
  private headers = new HttpHeaders({'Content-Type': 'application/json'});

  constructor(private http: HttpClient, private csihttp: CsiHttp) { }

  loginComToken(token: string) {
    return this.http.post(this.apiUrl + '/loginComToken', {token: token}, {headers: this.headers})
        .map((response: any) => {
            // login successful if there's a jwt token in the response
            // let token = response.json() && response.json().dadosUsuario && response.json().dadosUsuario.token;
            if (response && response.dadosUsuario && response.dadosUsuario.token) {
                 UserUtil.usuarioLogado = response.dadosUsuario;
                let funcoesPerm = UserUtil.usuarioLogado.funcoes;
                let funcoesAux = [];
                let f: Funcoes;
                for (let i = 0; i < funcoesPerm.length; i++) {
                  if (funcoesPerm[i] && funcoesPerm[i].pk && funcoesPerm[i].pk.cdFuncao) {
                    f = Funcoes[funcoesPerm[i].pk.cdFuncao];
                    if (f != null) {
                      funcoesAux.push(funcoesPerm[i]);
                    }
                  }
                }
                UserUtil.usuarioLogado.funcoes = funcoesAux;
                // store username and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify(UserUtil.usuarioLogado));

                // return true to indicate successful login
                return true;
            } else {
                // return false to indicate failed login
                return false;
            }
        });
  }

  login(username: string, password: string,usuarioAcessoCidadao: boolean): Observable<boolean> {
    /*let token = 'blablablabla';
    localStorage.setItem('currentUser', JSON.stringify({ username: username, token: token }));
    return true;*/
    return this.http.post(this.apiUrl + '/login', {username: username.toUpperCase(), password: password,usuarioAcessoCidadao: usuarioAcessoCidadao}, {headers: this.headers})
        .map((response: any) => {
            // login successful if there's a jwt token in the response
            // let token = response.json() && response.json().dadosUsuario && response.json().dadosUsuario.token;
            if (response && response.dadosUsuario && response.dadosUsuario.token) {
                 UserUtil.usuarioLogado = response.dadosUsuario;
                let funcoesPerm = UserUtil.usuarioLogado.funcoes;
                let funcoesAux = [];
                let f: Funcoes;
                for (let i = 0; i < funcoesPerm.length; i++) {
                  if (funcoesPerm[i] && funcoesPerm[i].pk && funcoesPerm[i].pk.cdFuncao) {
                    f = Funcoes[funcoesPerm[i].pk.cdFuncao];
                    if (f != null) {
                      funcoesAux.push(funcoesPerm[i]);
                    }
                  }
                }
                UserUtil.usuarioLogado.funcoes = funcoesAux;
                // store username and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify(UserUtil.usuarioLogado));

                // return true to indicate successful login
                return true;
            } else {
                // return false to indicate failed login
                return false;
            }
        });
  }

  registrarlogout(token) {
    SessionAnuglarService.logout();
    return this.http.post(this.apiUrl + '/registrarlogout', token)
      .map((response: any) => {
        return response;
      });
  }

  buscarParametros() {
    let url = this.apiUrl;
    url += '/dadosComum/getParametros/';

    return this.csihttp
      .get(url)
      .map((response: any) => {
        const dados = response;
        UserUtil.onLoadParametros.emit(dados.data);
        return dados;
      })
      .catch(this.handleError)
      .toPromise()
      .then(response => {
        if (!response) {
          return null;
        }
        const dados = response.data;
        UserUtil.onLoadParametros.emit(dados);
        return dados;
      });
  }

  private handleError(error: any) {
    let errMsg = error.message
      ? error.message
      : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

  atualizarLogin(token = null) {
    let url = this.apiUrl;
    url += '/atualizarLogin';

    return this.csihttp
      .post(url, null)
      .map((response: any) => {
        UserUtil.usuarioLogado.token = response.data;
        localStorage.setItem('currentUser', JSON.stringify(UserUtil.usuarioLogado));
        return response;
      });
  }


}



// WEBPACK FOOTER //
// ./src/app/commons/servicos/authentication.service.ts